import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import LayoutContext from '../../../../store/Layout/contexts';
import { newFetch, PUT, GET, DELETE } from '../../../../helpers/fetch';

const EditDoc = ({
  history,
  match: {
    params: { doc_id },
  },
}) => {
  const [doc, setDoc] = useState(null);
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState(0);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const fetchClients = async () => {
    let api_path = `/client`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  const fetchDoc = async () => {
    let api_path = `/edoc/${doc_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let docData = response.data;
      setDoc(docData);
      setClient(docData.client_id);
      setTitle(docData.title);
      setDescription(docData.description);
    }
  };

  const validateForm = () => {
    if (client === 0) {
      ToastUtil.error('Please select a Client!');
      return false;
    }

    if (!title) {
      ToastUtil.error('Please input Title!');
      return false;
    }

    if (!description) {
      ToastUtil.error('Please input Description!');
      return false;
    }

    return true;
  };

  const HandleSubmitUpdateDoc = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to update this Document?'
      ))
    ) {
      let api_path = `/edoc/${doc_id}`;
      let response = await newFetch(PUT, api_path, {
        title,
        description,
        client_id: parseInt(client),
      });

      ToastUtil.success(response.message);

      if (response.success) {
        history.push(`/edocs`);
      }
    }
  };

  const handleDiscard = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setClient(doc.client_id);
      setTitle(doc.title);
      setDescription(doc.description);
    }
  };

  const handleDeleteDoc = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Document?'
      )
    ) {
      let api_path = `/edoc/${doc_id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);

      response.success && history.push(`/edoc`);
    }
  };

  useEffect(() => {
    fetchDoc();
    fetchClients();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={`/edocs`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to eDocs
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Edit eDoc</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => HandleSubmitUpdateDoc(e)}>
              <div
                style={{
                  marginTop: '2rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded">
                  <div
                    style={{
                      width: '15rem',
                      backgroundColor: '#f3f3f3',
                      padding: '2.25rem',
                    }}
                    className="border-right"
                  >
                    <strong>eDoc Information</strong>
                    <p className="pt-2">Manage eDocs information</p>
                  </div>
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    <div className="row pb-3">
                      <strong>Client*</strong>
                      <select
                        name="client"
                        className="form-select mt-3 adjust-fs w-50"
                        value={client}
                        onChange={(e) => setClient(e.target.value)}
                      >
                        <option value={0}>Select Client</option>
                        {clients &&
                          clients.map((client) => (
                            <option key={client.id} value={client.id}>
                              {client.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="row pb-3">
                      <strong>Title*</strong>
                      <input
                        type="text"
                        className="form-control mt-3 adjust-fs"
                        placeholder="Title"
                        value={title}
                        onChange={({ target: { value } }) => setTitle(value)}
                      />
                    </div>
                    <div className="row pb-3">
                      <strong>Description*</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="Description"
                        value={description}
                        onChange={({ target: { value } }) =>
                          setDescription(value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-between"
              >
                <button
                  type="button"
                  className="btn btn-danger ms-4 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDeleteDoc}
                >
                  Delete
                </button>
                <div className="d-flex flex-row">
                  <button
                    type="button"
                    className="btn btn-outline-brand adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                    onClick={handleDiscard}
                  >
                    Discard
                  </button>
                  <button
                    type="submit"
                    className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Save changes
                  </button>
                </div>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditDoc);
